document.addEventListener("DOMContentLoaded", function () {
  const desc = document.querySelector(".product__description");

  if (!desc) return;

  // Loop through all elements inside the description
  desc.querySelectorAll("*").forEach((el) => {
    const style = el.getAttribute("style");

    if (style && style.includes("color")) {
      const cleaned = style
        .replace(/color\s*:\s*white\s*;?/gi, "color: #000 !important;")
        .replace(/color\s*:\s*#fff\s*;?/gi, "color: #000 !important;")
        .replace(/color\s*:\s*rgb\(255,\s*255,\s*255\)\s*;?/gi, "color: #000 !important;");

      el.setAttribute("style", cleaned);
    }
  });
});
